module.exports = {"TXTCLI_More":{"id":"TXTCLI_More","defaultMessage":"Mere","flags":["TRACK"],"track":"More"}}